export enum PatientIdTypeEnum {
  SSN = 'ssn',
  MRN = 'mrn',
}
